
import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MessagingService } from '../../../core/services/messaging.service';
import { OrganizationService } from '../../../core/services/organization.service';
import { MessageComponent } from '../message/message.component';

interface Recipient {
  userId: string;
  name: string;
}

@Component({
  selector: 'app-message-detail',
  standalone: true,
  imports: [
    FormsModule
],
  templateUrl: './message-detail.component.html',
  styleUrl: './message-detail.component.css'
})
export class MessageDetailComponent {

  @Input() item: any;
  @Input() isSent: boolean = false;
  @Input() attachmentUrl?: string;
  @Input() attachmentName?: string;
  @Input() messageVideoUrl?: string;
  recipientList: any = [];
  users: any = [];
  bodyHtml: SafeHtml = '';
  

  constructor(
    private sanitizer: DomSanitizer,
    public activeModal: NgbActiveModal,
    private messagingService: MessagingService,
    private organizationService: OrganizationService,
    private modalService: NgbModal,
  ) {}

  ngOnInit(): void {
    if (this.item?.bodyHtml) {
      this.bodyHtml = this.sanitizer.bypassSecurityTrustHtml(this.item.bodyHtml);
    }
    this.organizationService.getOrgUsers().subscribe(users => {
      this.users = users?.rows ?? [];
      this.getRecipientList();
    });
  }

 getRecipientList() {
  this.messagingService.getMessageRecipients(this.item.id).subscribe({
    next: (res) => {
      const rows = res?.rows || [];
      this.recipientList = rows.map((r: any) => {
        // find matching user in this.users
        const matchedUser = this.users.find((u: any) => String(u.id) === String(r.userId));
        return {
          userId: r.userId,
          name: matchedUser ? matchedUser.name : r.userId // fallback to userId if no match
        };
      });
      this.recipientList.sort((a: Recipient, b: Recipient) =>
        a.name.localeCompare(b.name)
      );

      // Build comma-separated string (same as AngularJS)
      this.item.recipients =
        this.recipientList.map((r: Recipient) => r.name).join(", ") + ", ";
    },
    error: (err) => {
      console.error('Error fetching recipients:', err);
    }
  });
}


  closeModal(): void {
    this.activeModal.dismiss(); // close the modal
  }

  /**
 * Reply to a message
 * @param mode 'single' for Reply, 'all' for Reply All
 */
  replyMail(mode: 'single' | 'all' = 'single'): void {
  // Extract sender info directly from FromMessageHeaders[0]
  const senderUserId: string = this.item?.FromMessageHeaders?.[0]?.userId ?? '';
  const senderUserFullName: string = this.item?.fromStr ?? senderUserId; 
  // fallback to userId if no display name

  // Start with sender (always included)
  let userItems: Recipient[] = [
    { userId: senderUserId, name: senderUserFullName }
  ];

  if (mode === 'all') {
    // Use Map to remove duplicates
    const allUsersMap = new Map<string, Recipient>();
    allUsersMap.set(senderUserId, { userId: senderUserId, name: senderUserFullName });

    // Add all recipients
    (this.recipientList as Recipient[]).forEach((r: Recipient) => {
      if (r?.userId) {
        allUsersMap.set(r.userId, r);
      }
    });

    // Convert Map back to array
    userItems = Array.from(allUsersMap.values());
  }

  // Open reply modal
  const modalRef = this.modalService.open(MessageComponent, { size: 'lg' });

  // Pass data into modal component
  modalRef.componentInstance.user = userItems[0]; // primary recipient
  modalRef.componentInstance.title = 'SMS';
}

}